import styled from 'styled-components';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';

export const LiveArenaWidgetCapsuleEndBox = styled.div`
    background: url(${props => props.theme.images.liveArena.liveArenaWidget.infoCapsule.backgroundEnd.toString()});
    background-size: 100% 100%;
    height: 100%;
    width: 55px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 40px;
    }
    ${CssRule.For.RTL.build()} & {
        transform: translateX(-0.5px) scaleX(-1);
    }
`;
